var login = {
  translation: {
    common: {
      accept: 'Prijať',
      alreadyUser: 'Už máte účet?',
      and: 'a',
      backToLogin: 'Späť na prihlasovaciu stránku',
      continueWith: 'Pokračovať s {{provider}}',
      createAccount: 'Vytvoriť účet',
      createYourAccount: 'Vytvorte si účet',
      emailOrUsername: 'Email alebo používateľské meno',
      login: 'Prihlásiť sa',
      logInToBoards: 'Prihlásiť sa',
      newToBoards: 'Nový v 4ga Boards?',
      pageNotFound_title: 'Stránka nenájdená',
      password: 'Heslo',
      privacyPolicy: 'Ochrana osobných údajov',
      register: 'Registrovať',
      registerWithGoogle: 'Registrovať cez Google',
      termsOfService: 'Všeobecné podmienky',
      togglePasswordVisibility: 'Zobraziť/skryť heslo',
    },

    action: {
      logIn: 'Prihlásiť sa',
    },
  },
};

export { login as default };
